import { render, staticRenderFns } from "./DataComponentList.vue?vue&type=template&id=4d8cdd9c"
import script from "./DataComponentList.vue?vue&type=script&lang=js"
export * from "./DataComponentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8cdd9c')) {
      api.createRecord('4d8cdd9c', component.options)
    } else {
      api.reload('4d8cdd9c', component.options)
    }
    module.hot.accept("./DataComponentList.vue?vue&type=template&id=4d8cdd9c", function () {
      api.rerender('4d8cdd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datav/DataComponentList.vue"
export default component.exports